import { Box, Grid, List, ListItem, Paper, ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import { theme } from "../../../../../styles"
import { useAppSelector } from "../../../../../hooks/store-hooks"
import { useProjetosService } from "../../../../../../use-cases/geo-veles"
import DonutSmallIcon from '@mui/icons-material/DonutSmall'
import ListAltIcon from '@mui/icons-material/ListAlt';
import { DadosGerais } from "./dados-gerais"
import { LevantamentoQuantitativo } from "./levantamento-quantitativo"

export const Detalhes = () => {
    // State
    const { activeDetailsSection } = useAppSelector((state) => state.projetos)
    // Hooks
    const { setActiveDetailsSection } = useProjetosService()

    return (<>
        <Box
            style={{
                marginBottom: '80px'
            }}
        >
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <List>
                        <ListItem key={0}
                        >
                            <Paper
                                elevation={3}
                                style={{
                                    width: '100%'
                                }}
                            >
                                <ListItemButton
                                    onClick={() => {
                                        setActiveDetailsSection(0)
                                    }}
                                    style={{
                                        background: activeDetailsSection === 0 ? theme.palette.primary.main : '',
                                        color: activeDetailsSection === 0 ? 'white' : 'black'
                                    }}
                                >
                                    <ListItemIcon>
                                        <DonutSmallIcon
                                            style={{
                                                color: activeDetailsSection === 0 ? 'white' : 'black'
                                            }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText primary={'Dados Gerais'.toUpperCase()} />
                                </ListItemButton>
                            </Paper>
                        </ListItem>
                        <ListItem key={1}>
                            <Paper
                                elevation={3}
                                style={{
                                    width: '100%'
                                }}
                            >
                                {/* <ListItemButton
                                    onClick={() => {
                                        setActiveDetailsSection(1)
                                    }}
                                    style={{
                                        background: activeDetailsSection === 1 ? theme.palette.primary.main : '',
                                        color: activeDetailsSection === 1 ? 'white' : 'black'
                                    }}
                                >
                                    <ListItemIcon>
                                        <ListAltIcon
                                            style={{
                                                color: activeDetailsSection === 1 ? 'white' : 'black'
                                            }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText primary={'Levantamento Quantitativo'.toUpperCase()} />
                                </ListItemButton> */}
                            </Paper>
                        </ListItem>
                    </List>
                </Grid>
                <Grid item xs={8}>
                    <Box p={2}>
                        {/* Dados Gerais */}
                        {activeDetailsSection === 0 && <DadosGerais />}
                        {/* Levantamento Quantitativo */}
                        {/* {activeDetailsSection === 1 && <LevantamentoQuantitativo />} */}
                    </Box>
                </Grid>
            </Grid>
        </Box>
    </>)
}